'use client';
import { usePrivy } from '@privy-io/react-auth';

/**
 * Returns the user's EVM (Ethereum) wallet address.
 *
 * Privy's `user.wallet` returns the most recently created wallet, which may
 * be an embedded Solana wallet.  This hook explicitly filters for the first
 * EVM wallet in the user's linked accounts to ensure compatibility with
 * EVM-based subgraph queries and contract interactions.
 */
export function useEvmWallet() {
  const { user, authenticated } = usePrivy();

  const evmWallet = user?.linkedAccounts?.find(
    (account) =>
      account.type === 'wallet' &&
      'chainType' in account &&
      account.chainType === 'ethereum',
  );

  const address =
    evmWallet && 'address' in evmWallet
      ? (evmWallet.address as `0x${string}`)
      : undefined;

  const isConnected = authenticated && !!address;

  return { address, isConnected };
}
